import { render } from "./EditIp.vue?vue&type=template&id=bda7d43c&ts=true"
import script from "./EditIp.vue?vue&type=script&lang=ts"
export * from "./EditIp.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\YellowBeardProject\\dobby\\dobbyshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__